import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { DxDataGridComponent, DxTooltipComponent } from 'devextreme-angular';
import { faCamera, faMale, faFemale } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { LanguageService } from '../../services/language.service';
import { UserService } from '../../services/user.service';
import { EmployeeService } from '../../../modules/employee/_api/services/employee.service';
import { AmsNotifierService } from '../../services/ams-notifier.service';
import { SetupEmployeeService } from '../../../modules/basic/_api/services/setup-employee.service';
import { WeekPlansService } from '../../../_api/services/week-plans.service';

@Component({
  selector: 'app-grid-employee',
  templateUrl: './grid-employee.component.html',
  styleUrls: ['./grid-employee.component.css']
})
export class GridEmployeeComponent implements OnInit {

  @Input() dataSourceEmployees: any;
  @Input() loadInit: boolean = true;
  calculationMethods: any;
  supervisors: any;
  departments: any;
  weekplans: any;
  salaryGroups: any;
  balanceGroups: any;
  genders: any[] = [];
  languages: any;
  salaryGroupSelectBox: any;
  selectedValueTransferSalary: boolean;
  toolTipColumn: string;
  titleEmployee: string;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(setup.component) to show load indicator
  @Output() employeeTagClick = new EventEmitter<any>();
  @Output() employeeClick = new EventEmitter<any>();

  @Input() showBtnCell: boolean = false;
  @Input() showDepartmentColumn: boolean = false;
  @Input() showHiredColumn: boolean = false;
  @Input() showEmailColumn: boolean = false;
  @Input() showLanguageColumn: boolean = false;
  @Input() showTransferSalaryColumn: boolean = false;
  @Input() showSupervisorColumn: boolean = false;
  @Input() showBalanceGroupColumn: boolean = false;
  @Input() showWeekPlanColumn: boolean = false;
  @Input() showSuspendBlockingDateColumn: boolean = false;
  @Input() groupPanelVisible: boolean = false;
  @Input() headerFilterVisible: boolean = false;
  @Input() classDataGrid: string = "grid-with-search";
  @Input() allowAdding: boolean = false;
  @Input() allowDeleting: boolean = true;

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxTooltipComponent) tooltip: DxTooltipComponent;

  selectedPhoto: any = null;
  faCamera = faCamera;
  faMale = faMale;
  faFemale = faFemale;

  constructor(public languageService: LanguageService, private userService: UserService, private employeeService: EmployeeService,
              private amsNotifierService: AmsNotifierService, private setupEmployeeService: SetupEmployeeService, 
              private weekPlanService: WeekPlansService) {}

  ngOnInit() {

    this.titleEmployee = this.languageService.LNG("Label.Employee");
    if (this.loadInit) {
      this.getEmployees();
    }
    this.getDepartments();
    this.getSupervisors();
    this.getWeekPlans();
    this.getCalculationMethods();
    this.getSalaryGroups();
    this.getBalanceGroups();
    this.getGenders();
    this.getLanguages();
  }

  @Input()
  set setDataSourceEmployees(datasource: DataSource) {
    this.dataSourceEmployees = datasource;
  }

  onEmployeeTagClick(data) {
    this.employeeTagClick.emit(data);
  }

  onCellClick(e) {
    if (e.rowType === "header") {
    }
    else {
      if (e.column.dataField !== undefined && !e.row.isEditing) {
        this.employeeClick.emit(e.data);
      }
    }
  }

  getEmployees() {
    this.loading.emit(true);
    let companyId = this.userService.account.CompanyId;

    this.dataSourceEmployees = new DataSource({
        load: (loadOptions) => {
          this.loading.emit(true);
          return this.setupEmployeeService.getEmployees(companyId).toPromise().then((data: any) => {
            this.loading.emit(false);
            return data;
          });
        },
        update: (key, values) => {
          this.loading.emit(true);
          let employee = {...key};
          employee.Photo = values.Photo ? values.Photo : key.Photo;
          employee.EmployeeNumber = values.EmployeeNumber !== undefined ? values.EmployeeNumber : key.EmployeeNumber;
          employee.FirstName = values.FirstName !== undefined ? values.FirstName : key.FirstName;
          employee.SurName = values.SurName !== undefined ? values.SurName : key.SurName;
          employee.DepartmentId = values.DepartmentId ? values.DepartmentId : key.DepartmentId;
          employee.Hired = values.Hired !== undefined ? values.Hired : key.Hired;
          employee.Quit = values.Quit !== undefined ? values.Quit : key.Quit;
          employee.Gender = values.Gender ? values.Gender : key.Gender;
          employee.UserId = values.UserId !== undefined ? values.UserId : key.UserId;
          employee.Email = values.Email !== undefined ? values.Email : key.Email;
          employee.Phone = values.Phone !== undefined ? values.Phone : key.Phone;
          employee.LanguageId = values.LanguageId ? values.LanguageId : key.LanguageId;
          employee.SupervisorId = values.SupervisorId ? values.SupervisorId : key.SupervisorId;
          employee.SuspendBlockingDate = values.SuspendBlockingDate !== undefined ? values.SuspendBlockingDate : key.SuspendBlockingDate;
          employee.CalculationMethod = values.CalculationMethod ? values.CalculationMethod : key.CalculationMethod;
          employee.WeekPlanId = values.WeekPlanId ? values.WeekPlanId : key.WeekPlanId;
          employee.ReportAccess = values.ReportAccess !== null && values.ReportAccess !== undefined ? values.ReportAccess : key.ReportAccess;
          employee.TransferSalaryGroupId = values.TransferSalaryGroupId ? values.TransferSalaryGroupId : key.TransferSalaryGroupId;
          employee.BalanceGroupId = values.BalanceGroupId ? values.BalanceGroupId : key.BalanceGroupId;

          return this.employeeService.updateEmployee(employee).toPromise().then((data: any) => {
            this.loading.emit(false);
            this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
            return data;
          });
        },
        insert: (values) => {

          this.loading.emit(true);
              return this.employeeService.insertEmployee(values).toPromise().then((data: any) => {
                this.loading.emit(false);

                if (data.IsSuccess) {
                  this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
                  return data;
                }
                else {
                  throw data.ErrorMessage;
                }
            }).catch(error => {
              this.loading.emit(false);
              let errormessage = this.languageService.LNG("ErrorMessage.Cannot.Insert.Employee");
              if (error) {
                if (error.message) {
                  errormessage = errormessage + " - " + error.message;
                }
                else {
                  errormessage = errormessage + " - " + error;
                }
              }
              throw errormessage;
            });
        },
        remove: (key) => {
          this.loading.emit(true);
          return this.employeeService.deleteEmployee(key.EmployeeId).toPromise().then((data: any) => {
            this.loading.emit(false);
            this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOk"));
            return data;
          });
        } ,
        errorHandler: (error) => {
            this.loading.emit(false);
            alert(error.message);
        }
    });
  }

  getEmployeeBySearch(viewModel) {

  }

  onCellPrepared(e) {
    if (e.column.command === 'edit') {
    }
  }

  contentReadyFileUploader(e) {
    let buttonInstance = e.component._selectButton;

    if(buttonInstance) {
      buttonInstance.option('icon', 'photo');
      let icon = buttonInstance.element().querySelectorAll("i")[0];
      let	parentNode = icon.parentNode;
      let	newIcon = document.createElement("fa-icon");
    }
  }

  setPhotoValue(newData, value) {
    newData.Photo = value;
  }

  onValueChangedPhoto(e, cell) {
    if (e.target.files[0] !== null) {
        var reader = new FileReader();
        reader.onload = function(e) {
          cell.setValue(reader.result);
        };
        reader.readAsDataURL(e.target.files[0]);
    }
  }

  private async getSupervisors() {
    this.supervisors = await this.employeeService.getSupervisors().toPromise();
  }

  private async getDepartments() {
    this.departments = await this.employeeService.getDepartments().toPromise();
  }

  private async getWeekPlans() {
    this.weekplans = await this.weekPlanService.get().toPromise();
  }

  getCalculationMethods() {
    this.employeeService.getCalculationMethods()
    .subscribe((result: any) => { 

      this.calculationMethods = result;
    }, error => { 
    });
  }

  getSalaryGroups() {
    this.employeeService.getSalaryGroups()
    .subscribe((result: any) => { 

      this.salaryGroups = result;
    }, error => { 
    });
  }

  onSalaryGroupChanged(e, cell) {
    let selectedSalaryGroup = e.component.option("selectedItem");

    if (selectedSalaryGroup) {
      cell.setValue(selectedSalaryGroup.GroupId);
      cell.data.TransferSalaryGroupId = selectedSalaryGroup.GroupId;
    }
    else {
      cell.setValue(-1);
      cell.data.TransferSalaryGroupId = -1;
    }
  }

  setSalaryGroupValue(newData, value) {
    newData.TransferSalaryGroupId = value;
  }

  getBalanceGroups() {
    this.employeeService.getBalanceGroups()
    .subscribe((result: any) => { 

      this.balanceGroups = result;
    }, error => { 
    });
  }

  onBalanceGroupChanged(e, cell) {
    let selectedBalanceGroup = e.component.option("selectedItem");
    if (selectedBalanceGroup) {
      cell.setValue(selectedBalanceGroup.GroupId);
      cell.data.BalanceGroupId = selectedBalanceGroup.GroupId;
    }
    else {
      cell.setValue(-1);
      cell.data.BalanceGroupId = -1;
    }
  }

  setBalanceGroupValue(newData, value) {
    newData.BalanceGroupId = value;
  }

  getGenders() {
    this.genders.push({
      Gender: "M",
      Icon: "faMale"
    });
    this.genders.push({
      Gender: "F",
      Icon: "faFemale"
    });
  }

  setGenderValue(newData, value) {
    newData.Gender = value;
  }

  onGenderValueChanged(e, cell) {
    let selectedGender = e.component.option("selectedItem");
    if (selectedGender) {
      cell.setValue(selectedGender.Gender);
    }
    else {
      cell.setValue(-1);
    }
  }

  getLanguages() {
    this.employeeService.getLanguages()
    .subscribe((result: any) => { 

      this.languages = result;
    }, error => { 
    });
  }

  onLanguageChanged(e, cell) {
    let selectedLanguage = e.component.option("selectedItem");
    if (selectedLanguage) {
      cell.setValue(selectedLanguage.LanguageId);
      cell.data.LanguageId = selectedLanguage.LanguageId;
    }
    else {
      cell.setValue(-1);
      cell.data.LanguageId = -1;
    }
  }

  setLanguageValue(newData, value) {
    newData.LanguageId = value;
    newData.LanguageCode = "jk";//need to set something to pass validation. cannot set selectedLanguage object in cell.setValue for some reason
  }

  onHiredDateChanged(e, cell) {
    let dt = e.value != null ? moment(e.value) : e.value;
    cell.setValue(dt != null ? dt.format("YYYY-MM-DDTHH:mm:ss") : "");
  }

  setHiredDateValue(newData, value) {
    newData.Hired = value;
  }

  onQuitDateChanged(e, cell) {
    let dt = e.value != null ? moment(e.value) : e.value;
    cell.setValue(dt != null ? dt.format("YYYY-MM-DDTHH:mm:ss") : "");
  }

  setQuitDateValue(newData, value) {
    newData.Quit = value;
  }

  onSuspendBlockingDateChanged(e, cell) {
    let dt = e.value != null ? moment(e.value) : e.value;
    cell.setValue(dt != null ? dt.format("YYYY-MM-DDTHH:mm:ss") : "");
  }

  setSuspendBlockingDateValue(newData, value) {
    newData.SuspendBlockingDate = value;
  }

  onEditorPreparing (e) {
    if (e.parentType == 'dataRow' && e.dataField == 'TransferToSalary') {
      var transferToSalaryCheckBox = e.editorElement.dxCheckBox('instance');
      this.selectedValueTransferSalary = transferToSalaryCheckBox.option("value");

      transferToSalaryCheckBox.option('onValueChanged', function (e) {
        this.selectedValueTransferSalary = e.component.option("value");
        this.salaryGroupSelectBox.option("disabled", !this.selectedValueTransferSalary);
      });
    }
    if (e.parentType == 'dataRow' && e.dataField == 'TransferToSalaryGroup') {
      this.salaryGroupSelectBox = e.editorElement.dxSelectBox('instance');
      this.salaryGroupSelectBox.option("disabled", this.selectedValueTransferSalary);
    }
  }

  //tooltip to certain columns
  onCellHoverChanged(e) {
    this.tooltip.instance.hide();
    this.toolTipColumn = "";
    if (e.rowType == "header") {
      if (e.column.caption == this.languageService.LNG('Label.Empl.No')) {
        this.toolTipColumn = this.languageService.LNG('Label.Employeenumber.Used.In.Salarysystem');
        this.tooltip.target = e.cellElement;
        this.tooltip.instance.show();
      }
      else if (e.column.caption == this.languageService.LNG('Label.Username')) {
        this.toolTipColumn = this.languageService.LNG('Label.Unique.Login.Name');
        this.tooltip.target = e.cellElement;
        this.tooltip.instance.show();
      }
      else if (e.column.caption == this.languageService.LNG('Label.Calculation')) {
        this.toolTipColumn = this.languageService.LNG('Label.Calculation.Type');
        this.tooltip.target = e.cellElement;
        this.tooltip.instance.show();
      }
      else if (e.column.caption == this.languageService.LNG('Label.Report')) {
        this.toolTipColumn = this.languageService.LNG('Label.Access.To.Time.Report');
        this.tooltip.target = e.cellElement;
        this.tooltip.instance.show();
      }
      else if (e.column.caption == this.languageService.LNG('Label.Salary')) {
        this.toolTipColumn = this.languageService.LNG('Label.Salary.Group');
        this.tooltip.target = e.cellElement;
        this.tooltip.instance.show();
      }
      else if (e.column.caption == this.languageService.LNG('Label.Balance')) {
        this.toolTipColumn = this.languageService.LNG('Label.Balance.Group');
        this.tooltip.target = e.cellElement;
        this.tooltip.instance.show();
      }
    }
  }

  onAddNewRow() {

    this.dataGrid.instance.addRow();
  }

  onInitNewRow(e) {
    e.data.ReportAccess = false;
    e.data.TransferSalary = false;
    e.data.UseBalance = false;
  }

  onRefresh() {
    if (this.loadInit) {
      this.getEmployees();
    }
    this.getCalculationMethods();
    this.getSalaryGroups();
    this.getBalanceGroups();
  }

  onSave() {

    this.dataGrid.instance.saveEditData();
  }

  customizeExportData(cols, rows) {

    var lngYes = this.languageService.LNG("Label.Yes");
    var lngNo = this.languageService.LNG("Label.No");
    rows.forEach(row => {

      let balance = row.values[row.values.length - 1];
      if (balance) {
        row.values[row.values.length - 1] = lngYes;
      }
      else {
        row.values[row.values.length - 1] = lngNo;
      }
      let salary = row.values[row.values.length - 2];
      if (salary) {
        row.values[row.values.length - 2] = lngYes;
      }
      else {
        row.values[row.values.length - 2] = lngNo;
      }
      let report = row.values[row.values.length - 3];
      if (report) {
        row.values[row.values.length - 3] = lngYes;
      }
      else {
        row.values[row.values.length - 3] = lngNo;
      }
    });
  }

}
